import React from 'react';
import { X, Star } from 'lucide-react';
import { formatCurrency, formatNumber } from '../../utils/formatters';

const ComparisonColumnHeader = ({ property, scenarioName, onRemove, savedScenarios, onLoadScenario, wins, isTopPick }) => {
    return (
        <div className="ct-col-header">
            <button className="ct-remove-btn" onClick={onRemove} aria-label="Remove column">
                <X size={14} />
            </button>
            {property?.primary_photo_url ? (
                <img src={property.primary_photo_url} alt="" className="ct-col-photo" />
            ) : (
                <div className="ct-col-photo ct-col-photo-placeholder" />
            )}
            <div className="ct-col-address">{property?.address}</div>
            <div className="ct-col-location">{property?.city}, {property?.state}</div>
            <div className="ct-col-specs">
                {property?.beds} bd | {property?.baths} ba | {formatNumber(property?.sqft)} sqft
            </div>
            <div className="ct-col-price">{formatCurrency(property?.list_price)}</div>
            <span className={`ct-scenario-badge ${scenarioName ? 'named' : ''}`}>
                {scenarioName || 'Default'}
            </span>
            {wins > 0 && (
                <div className={`ct-col-wins${isTopPick ? ' top-pick' : ''}`}>
                    <Star size={12} fill="currentColor" />
                    <span>{wins} {wins === 1 ? 'win' : 'wins'}</span>
                    {isTopPick && <span className="ct-top-pick-label">Top Pick</span>}
                </div>
            )}
            {savedScenarios && savedScenarios.length > 0 && (
                <select
                    className="ct-scenario-select"
                    defaultValue=""
                    onChange={e => {
                        const scenario = savedScenarios.find(s => s.id === e.target.value);
                        if (scenario) onLoadScenario(scenario);
                        e.target.value = '';
                    }}
                >
                    <option value="" disabled>Load scenario...</option>
                    {savedScenarios.map(s => (
                        <option key={s.id} value={s.id}>
                            {s.name} ({(s.results?.cashOnCashROI || 0).toFixed(1)}%)
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

export default ComparisonColumnHeader;
